module.exports = __webpack_public_path__ + "static/media/md.75ec533a.svg";